<template>
  <q-page id="pagina">
    <div class="cabecera">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit nihil praesentium molestias a adipisci, dolore vitae odit, quidem consequatur optio voluptates asperiores pariatur eos numquam rerum delectus commodi perferendis voluptate?
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit nihil praesentium molestias a adipisci, dolore vitae odit, quidem consequatur optio voluptates asperiores pariatur eos numquam rerum delectus commodi perferendis voluptate?
    </div>
    <div class="container">
      <div class="contenido">
        
      </div>
    </div>
    <div class="footer">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit nihil praesentium molestias a adip isci, dolore vitae odit, quidem consequatur optio voluptates asperiores pariatur eos numquam rerum delectus commodi perferendis voluptate?
    </div>
  </q-page>
</template>

<script>

export default {
  components: {
  },
  data: () => {
    return {
      width: '' ,
      height: '',
    }
  },
  methods: {
    checkSize() {
      let contenido = document.getElementsByClassName('contenido')[0];
      console.log('checkSize, contenido:', contenido.offsetWidth, contenido.offsetHeight);
    }
  },
  deactivated() {
    console.log('desactivando componente flexbox');
  },
  
  mounted() {
    console.log('montando componente flexbox');
    this.checkSize();
  }
}
</script>

<style lang="scss">
#pagina {
  display: flex;
  // height: inherit;
  flex-flow: column nowrap
}
.container {
  display: flex;
  background-color: blanchedalmond;
  // height: inherit;
  flex: 1;
}
.contenido {
  width: 100%
}
.footer {
  margin-top: auto
}

</style>